const ClientDocumentTypes = {
    // Get Clients
    GET_CLIENTS: "GET_CLIENTS",
    GET_CLIENTS_LOADING: "GET_CLIENTS_LOADING",
    GET_CLIENTS_SUCCESS: "GET_CLIENTS_SUCCESS",
    GET_CLIENTS_ERROR: "GET_CLIENTS_ERROR",

    // Get Projects
    GET_PROJECTS: "GET_PROJECTS",
    GET_PROJECTS_LOADING: "GET_PROJECTS_LOADING",
    GET_PROJECTS_SUCCESS: "GET_PROJECTS_SUCCESS",
    GET_PROJECTS_ERROR: "GET_PROJECTS_ERROR",

    // Upload Document
    UPLOAD_DOCUMENT: "UPLOAD_DOCUMENT",
    UPLOAD_DOCUMENT_LOADING: "UPLOAD_DOCUMENT_LOADING",
    UPLOAD_DOCUMENT_SUCCESS: "UPLOAD_DOCUMENT_SUCCESS",
    UPLOAD_DOCUMENT_RESET: "UPLOAD_DOCUMENT_RESET",
    UPLOAD_DOCUMENT_ERROR: "UPLOAD_DOCUMENT_ERROR",

    // Get Documents
    GET_DOCUMENTS: "GET_DOCUMENTS",
    GET_DOCUMENTS_LOADING: "GET_DOCUMENTS_LOADING",
    GET_DOCUMENTS_SUCCESS: "GET_DOCUMENTS_SUCCESS",
    GET_DOCUMENTS_ERROR: "GET_DOCUMENTS_ERROR",

    // Delete Document
    DELETE_DOCUMENT: "DELETE_DOCUMENT",
    DELETE_DOCUMENT_LOADING: "DELETE_DOCUMENT_LOADING",
    DELETE_DOCUMENT_SUCCESS: "DELETE_DOCUMENT_SUCCESS",
    DELETE_DOCUMENT_RESET: "DELETE_DOCUMENT_RESET",
    DELETE_DOCUMENT_ERROR: "DELETE_DOCUMENT_ERROR",
};

export default ClientDocumentTypes;